import { CryptoError, InvalidArgumentError, } from '#types/sdk/workspace-client/index';
import { MemberCryptoFromSecretKey } from './member-crypto-from-secret-key';
export class MemberCryptoFromWorkspaceKey extends MemberCryptoFromSecretKey {
    secretKey;
    constructor(member, workspaceKey, logger) {
        super(member, logger);
        this.secretKey = workspaceKey;
        if (!member.invitation.ePrivateKeyBySsoSecret) {
            throw new InvalidArgumentError(`Cannot create ${MemberCryptoFromWorkspaceKey.name} with missing invitation.ePrivateKeyBySsoKey.`);
        }
    }
    getEncryptedInvitationKey() {
        if (!this.member.invitation.ePrivateKeyBySsoSecret) {
            throw new CryptoError('ePrivateKeyBySsoSecret is missing');
        }
        return this.member.invitation.ePrivateKeyBySsoSecret;
    }
}
